export const TRANSLATIONS_FR_SHELL_AND_COMMON = {
  "common.yes": "Oui",
  "common.no": "Non",
  "notifications.title": "Notifications",
  "notifications.markAllRead": "Tout marquer comme lu",
  "navbar.brand": "Système RAG",
  "nav.home": "Accueil",
  "nav.expandSidebar": "Développer la barre latérale",
  "nav.collapseSidebar": "Réduire la barre latérale",
  "nav.notifications": "Notifications",
  "nav.userMenu": "Menu utilisateur",
  "nav.help": "Aide",
  "nav.chat": "Chat",
  "nav.upload": "Téléverser des documents",
  "nav.dashboard": "Tableau de bord",
  "nav.profile": "Profil",
  "nav.settings": "Préférences",
  "nav.logout": "Déconnexion",
  "nav.query": "Requête",
  "nav.about": "À propos",
  "nav.tasks": "Tâches",
  "nav.plan": "Forfait",
  "plan.tabs.overview": "Mon forfait",
  "plan.tabs.detail": "Détails",
  "auth.login": "Connexion",
  "auth.or": "ou",
  "auth.signup": "S'inscrire",
  "auth.powered_by": "Développé par",
  " ": "Double clic pour télécharger",
  "common.close": "Fermer",
  "common.options": "Options",
  "common.cancel": "Annuler",
  "nav.documents": "Documents",
  "header.help": "Aide",
  "header.theme.switchToLight": "Passer au thème clair",
  "header.theme.switchToDark": "Passer au thème sombre",
  "role.admin": "Administrateur",
  "role.user": "Utilisateur",
  "footer.rights": "Tous droits réservés.",
  "footer.terms": "Conditions d'utilisation",
  "footer.privacy": "Politique de confidentialité",
  "footer.contact": "Contact",
  "auth.create_account": "Créer un compte",
  "auth.signup_description": "Créez un compte pour commencer",
  "auth.back_to_login": "Retour à la connexion",
  "auth.loading": "Chargement...",
  "auth.redirecting": "Redirection...",
  "nav.admin": "Administration",
  "notifications.empty": "Aucune notification",
  "role.executive": "Cadre",
  "breadcrumbs.input.label": "Emplacement du fichier",
  "breadcrumbs.popover.create_option": "Créer un dossier",
  "breadcrumbs.modal.label": "Nom du dossier",
  "breadcrumbs.modal.button.cancel": "Annuler",
  "breadcrumbs.modal.button.create": "Créer",
  "common.save": "Enregistrer",
  "common.email": "E-mail",
  "common.role": "Rôle",
  "common.created": "Créé",
  "common.actions": "Actions",
  "common.page": "Page",
  "common.of": "sur",
  "common.prev": "Précédent",
  "common.next": "Suivant",
  "common.status": "Statut",
  "common.name": "Nom",
  "common.records": "enregistrements",
  "common.inactive": "Inactif",
  "common.activate": "Activer",
  "common.deactivate": "Désactiver",
  "common.sending": "Envoi...",
  "errors.email_required": "L'e-mail est requis.",
  "errors.email_invalid": "Format d'e-mail invalide.",
  "errors.role_required": "Le rôle est requis.",
  "nav.generate": "Documents Générés",
  "nav.knowledge": "Connaissances",
  "nav.changes": "Modifications",
  "nav.alerts": "Alertes",
  "nav.knowledgeHub": "Knowledge Hub",
};
